var map = {
	"./add.svg": 791,
	"./arrow-left.svg": 306,
	"./arrow-simple-vertical.svg": 341,
	"./arrow-simple.svg": 249,
	"./arrow.svg": 508,
	"./bring-backward.svg": 792,
	"./bring-forward.svg": 793,
	"./camera.svg": 506,
	"./center.svg": 494,
	"./checkmark-bold.svg": 378,
	"./checkmark.svg": 484,
	"./close.svg": 247,
	"./copy.svg": 248,
	"./delete.svg": 206,
	"./dots.svg": 305,
	"./edit.svg": 794,
	"./eye.svg": 795,
	"./facebook-square.svg": 507,
	"./file.svg": 796,
	"./flash-error.svg": 369,
	"./flash-success.svg": 673,
	"./flash-warning.svg": 370,
	"./flip.svg": 493,
	"./font-size-decrease.svg": 491,
	"./font-size-increase.svg": 492,
	"./font.svg": 490,
	"./gallery.svg": 502,
	"./help.svg": 500,
	"./info.svg": 501,
	"./instagram-filled.svg": 509,
	"./lock.svg": 797,
	"./magnifying-glass.svg": 798,
	"./move-backward.svg": 486,
	"./move-forward.svg": 487,
	"./movement-handle.svg": 343,
	"./pb-menu-toggle.svg": 499,
	"./period.svg": 799,
	"./plus.svg": 485,
	"./repeat.svg": 800,
	"./resize-large.svg": 495,
	"./resize-small.svg": 496,
	"./rotate-left.svg": 376,
	"./rotate-right.svg": 377,
	"./save.svg": 510,
	"./shapes.svg": 503,
	"./size.svg": 801,
	"./sort.svg": 802,
	"./text-align-center.svg": 348,
	"./text-align-justify.svg": 372,
	"./text-align-left.svg": 349,
	"./text-align-right.svg": 373,
	"./text-bold.svg": 468,
	"./text-color.svg": 374,
	"./text-field.svg": 504,
	"./text-italic.svg": 469,
	"./text-underline.svg": 375,
	"./trash.svg": 371,
	"./unit-rotate-left.svg": 497,
	"./unit-rotate-right.svg": 498,
	"./upload.svg": 803,
	"./warning-triangle.svg": 804,
	"./warning.svg": 805,
	"./zoom-in.svg": 488,
	"./zoom-out.svg": 489,
	"./zoom.svg": 806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 790;